import { DeclarationRevendication } from './declaration-revendication.model';
import { DeclarationIgp } from './declaration-igp.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Declarations {
    static jsonMap = {
        aocs: { key: 'aocs', converter: new (ArrayClassConverterFactory.build(DeclarationRevendication))(), default: () => [] },
        igps: { key: 'igps', converter: new (ArrayClassConverterFactory.build(DeclarationIgp))(), default: () => [] }
    };

    aocs: DeclarationRevendication[];
    igps: DeclarationIgp[];
}
